/**
 * Application Constants
 * Central location for all constant values used across the application
 */

/**
 * Communication Channel Types
 * Defines the available communication channels for campaigns
 */
export const COMMUNICATION_CHANNEL = {
  EMAIL: 'EMAIL',
  WHATSAPP: 'WHATSAPP'
};

/**
 * Campaign Status Types
 */
export const CAMPAIGN_STATUS = {
  DRAFT: 'DRAFT',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED'
};

/**
 * User Roles
 */
export const USER_ROLE = {
  ADMIN: 'ADMIN',
  STAFF: 'STAFF'
};

/**
 * Contact Types
 */
export const CONTACT_TYPE = {
  INDIVIDUAL: 'INDIVIDUAL',
  ORGANIZATION: 'ORGANIZATION'
};

/**
 * Contact Preferred Channels
 */
export const CONTACT_PREFERRED_CHANNEL = {
  EMAIL: 'EMAIL',
  CALL: 'CALL',
  SMS: 'SMS'
};
